import { service } from "."

export default {
  getAll: (data) => service.post("/showpublics/search", data),
  getAllForMap: (data) => service.post("/showpublics/maps", data),
  getOne: (id) => service.get(`/showpublics/${id}`),
  update: (id, data) => service.put(`showpublics/site/${id}`, data),
  seen: (id) => service.get(`/showpublics/seen/${id}`),
}
